import React from 'react'

const Label = ({ children, className }) => {
    return (
        <div className={`text-label font-poppins desktopMd:text-2xl desktopXmd:text-3xl desktopLg:text-4xl desktopXlg:text-5xl ${className}`}>{children}</div>
    )
}

export default Label